module.exports = __webpack_public_path__ + "static/media/PRACTICA10.4acd63df.jpeg";